export enum AppointmentTypes {
    SIMPLE = 1,
    DOUBLE = 2,
}
